import React, { useState } from 'react';
import { Button, Modal } from 'tt-ui-lib/core';
import { ReactComponent as DocIco } from '../../../../assets/svg/doc.svg';
import styles from './ReportGenerate.module.scss';
import { Cookies } from 'react-cookie-consent';
import { useSelectedContext } from 'context/contextSelector';
import axios from 'axios';

const ttRestHost = `${process.env.REACT_APP_SSO_API}/tt-ai`;

const BUTTON_TEXT = `Generate report`;
const TITLE = `Are you sure you are ready to start generating report?`;
const MESSAGE = `Please check the questions and answers before starting report generation. Only
          successfully processed data will be included in the report`;

const ReportGenerate = (props) => {
  const {
    reportId,
    reportType,
    onError,
    onGenerate = null,
    onSuccess = null,
    buttonText = BUTTON_TEXT,
    message = MESSAGE,
    title = TITLE,
  } = props;
  const [isReportModalOpened, setIsReportModalOpened] = useState();
  const { user } = useSelectedContext((context) => context.user);

  const generateReport = () => {
    if (onGenerate) onGenerate();
    else {
      const token = Cookies.get('access_token');
      const headers = {
        authorization: token ? `Bearer ${token}` : '',
        Userid: user.id,
      };
      const par = `?source_id=${reportId}&source=${reportType}`;
      const url = `${ttRestHost}/reports/generate${par}`;

      axios
        .get(url, { headers })
        .then((resp) => {
          const { data, success } = resp;
          if (success && onSuccess) onSuccess(data);
        })
        .catch((err) => onError(err));
      setIsReportModalOpened(false);
    }
  };

  return (
    <>
      <Button type="default" onClick={() => setIsReportModalOpened(true)} startIcon={<DocIco />}>
        {buttonText}
      </Button>
      <Modal
        open={isReportModalOpened}
        onClose={() => setIsReportModalOpened(false)}
        onClick={(e) => e.stopPropagation()}
        title={title}
        className={styles.warningModal}
      >
        <div>{message}</div>
        <div className={styles.buttonBlock}>
          <Button type="default" onClick={() => setIsReportModalOpened(false)}>
            Cancel
          </Button>
          <Button type="primary" onClick={generateReport}>
            {buttonText}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ReportGenerate;
